// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"2651939b","774":"555a8177"}[chunkId] + ".chunk.js";
};